module.exports = __webpack_public_path__ + "static/media/our_products.f8ae9dee.jpg";